const is = (r, status) => r?.preparationStatus?.toLowerCase() === status;

export const isOfferPreparing = (r) => is(r, "preparing");
export const isOfferPreparationFailed = (r) => is(r, "failed");

export const isOfferLinkLocked = (r) => isOfferPreparing(r) || isOfferPreparationFailed(r);

export const offerLinkLockedKey = (r) => (isOfferPreparationFailed(r) ? "offerPreparation.linkUnavailableFailed" : "offerPreparation.linkUnavailable");
